document.addEventListener('DOMContentLoaded', () => {
    console.log('Mobile subnav script loaded')

    // Mobile megamenu accordion functionality
    const mobileMegamenuToggles = document.querySelectorAll(
        '.mobile-megamenu-toggle'
    )
    //  console.log('Found mobile megamenu toggles:', mobileMegamenuToggles.length)

    mobileMegamenuToggles.forEach((toggle) => {
        console.log('Setting up toggle:', toggle.getAttribute('data-target'))
        toggle.addEventListener('click', function (e) {
            e.preventDefault()
            e.stopPropagation()

            const targetId = this.getAttribute('data-target')
            const megamenuContent = document.getElementById(targetId)
            const isExpanded = this.getAttribute('aria-expanded') === 'true'
            const toggleIcon = this.querySelector('svg')

            if (!megamenuContent) {
                return
            }

            // Toggle the megamenu visibility
            if (isExpanded) {
                // Close the megamenu
                console.log('Closing megamenu:', targetId)
                megamenuContent.classList.add('hidden')
                megamenuContent.style.display = 'none'
                this.setAttribute('aria-expanded', 'false')
                if (toggleIcon) {
                    toggleIcon.style.transform = 'rotate(0deg)'
                }
            } else {
                // Close any other open megamenus first (accordion behavior)
                const allMegamenus = document.querySelectorAll(
                    '.mobile-megamenu-content'
                )
                const allToggles = document.querySelectorAll(
                    '.mobile-megamenu-toggle'
                )

                allMegamenus.forEach((menu) => {
                    if (menu !== megamenuContent) {
                        menu.classList.add('hidden')
                        menu.style.display = 'none'
                    }
                })

                allToggles.forEach((tog) => {
                    if (tog !== this) {
                        tog.setAttribute('aria-expanded', 'false')
                        const otherIcon = tog.querySelector('svg')
                        if (otherIcon) {
                            otherIcon.style.transform = 'rotate(0deg)'
                        }
                    }
                })

                // Open the current megamenu
                console.log('Opening megamenu:', targetId)
                megamenuContent.classList.remove('hidden')
                megamenuContent.style.display = 'block'
                this.setAttribute('aria-expanded', 'true')
                if (toggleIcon) {
                    toggleIcon.style.transform = 'rotate(180deg)'
                }
            }
        })
    })

    // Mobile subnav accordion functionality
    const mobileSubnavToggles = document.querySelectorAll(
        '.mobile-subnav-toggle'
    )
    // console.log('Found mobile subnav toggles:', mobileSubnavToggles.length)

    mobileSubnavToggles.forEach((toggle) => {
        toggle.addEventListener('click', function (e) {
            e.preventDefault()
            e.stopPropagation()

            const targetId = this.getAttribute('data-target')
            const subnav = document.getElementById(targetId)
            const isExpanded = this.getAttribute('aria-expanded') === 'true'
            const toggleIcon = this.querySelector('svg')

            console.log(
                'Subnav toggle clicked:',
                targetId,
                'Found element:',
                !!subnav,
                'Is expanded:',
                isExpanded
            )

            if (!subnav) return

            // Toggle the subnav visibility
            if (isExpanded) {
                // Close the subnav
                subnav.classList.add('hidden')
                this.setAttribute('aria-expanded', 'false')
                if (toggleIcon) {
                    toggleIcon.style.transform = 'rotate(0deg)'
                }
            } else {
                // Close any other open subnavs first (accordion behavior)
                const allSubnavs = document.querySelectorAll('.mobile-subnav')
                const allToggles = document.querySelectorAll(
                    '.mobile-subnav-toggle'
                )

                allSubnavs.forEach((nav) => {
                    if (nav !== subnav) {
                        nav.classList.add('hidden')
                    }
                })

                allToggles.forEach((tog) => {
                    if (tog !== this) {
                        tog.setAttribute('aria-expanded', 'false')
                        const otherIcon = tog.querySelector('svg')
                        if (otherIcon) {
                            otherIcon.style.transform = 'rotate(0deg)'
                        }
                    }
                })

                // Open the current subnav
                subnav.classList.remove('hidden')
                this.setAttribute('aria-expanded', 'true')
                if (toggleIcon) {
                    toggleIcon.style.transform = 'rotate(180deg)'
                }
            }
        })
    })

    // Close all megamenus and subnavs when clicking outside
    document.addEventListener('click', function (e) {
        if (
            !e.target.closest('.mobile-megamenu-toggle') &&
            !e.target.closest('.mobile-megamenu-content') &&
            !e.target.closest('.mobile-subnav-toggle') &&
            !e.target.closest('.mobile-subnav')
        ) {
            // Close all megamenus
            const allMegamenus = document.querySelectorAll(
                '.mobile-megamenu-content'
            )
            const allMegamenuToggles = document.querySelectorAll(
                '.mobile-megamenu-toggle'
            )

            allMegamenus.forEach((menu) => {
                menu.classList.add('hidden')
                menu.style.display = 'none'
            })

            allMegamenuToggles.forEach((toggle) => {
                toggle.setAttribute('aria-expanded', 'false')
                const toggleIcon = toggle.querySelector('svg')
                if (toggleIcon) {
                    toggleIcon.style.transform = 'rotate(0deg)'
                }
            })

            // Close all subnavs
            const allSubnavs = document.querySelectorAll('.mobile-subnav')
            const allSubnavToggles = document.querySelectorAll(
                '.mobile-subnav-toggle'
            )

            allSubnavs.forEach((nav) => {
                nav.classList.add('hidden')
            })

            allSubnavToggles.forEach((toggle) => {
                toggle.setAttribute('aria-expanded', 'false')
                const toggleIcon = toggle.querySelector('svg')
                if (toggleIcon) {
                    toggleIcon.style.transform = 'rotate(0deg)'
                }
            })
        }
    })
})
